const INVALID_TRACKING_VALUES = new Set(['undefined', 'null', 'nan']);

export function sanitizeTrackingValue(value: unknown): string | null {
  if (typeof value !== 'string') {
    return null;
  }

  const normalizedValue = value.trim();
  if (!normalizedValue) {
    return null;
  }

  if (INVALID_TRACKING_VALUES.has(normalizedValue.toLowerCase())) {
    return null;
  }

  return normalizedValue;
}
